import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSecurity = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_892_19518",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_892_19518)",
		children: /* @__PURE__ */ _jsx("path", { d: "M12 21.4807C9.83716 20.891 8.04646 19.6179 6.62787 17.6615C5.20929 15.7051 4.5 13.5179 4.5 11.1V5.34619L12 2.53851L19.5 5.34619V11.1C19.5 13.5179 18.7907 15.7051 17.3721 17.6615C15.9535 19.6179 14.1628 20.891 12 21.4807ZM12 19.9C13.6166 19.4 14.9666 18.4125 16.05 16.9375C17.1333 15.4625 17.7666 13.8167 17.95 12H12V4.13464L5.99997 6.37501V11.5404C5.99997 11.6635 6.01664 11.8167 6.04997 12H12V19.9Z" })
	})]
});
export default SvgSecurity;
